// Uses the official PLST logo asset as-is. Never redraw / restyle.
// variant="full"    -> full lockup (P L S T + barbell + tagline)  — transparent PNG
// variant="barbell" -> barbell mark only, cleanly extracted        — transparent PNG
export default function Logo({
  className = "",
  size = 40,
  variant = "full",
  alt = "PLST — Physio-Led Strength Training",
}) {
  if (variant === "full-trim") {
    return (
      <img
        src="/plst-logo-trim.png"
        alt={alt}
        className={className}
        style={{ display: "block", height: size, width: "auto", objectFit: "contain" }}
        draggable={false}
      />
    );
  }
  if (variant === "barbell") {
    return (
      <img
        src="/plst-barbell.png"
        alt={alt}
        className={className}
        style={{ display: "block", height: size, width: "auto", objectFit: "contain" }}
        draggable={false}
      />
    );
  }
  return (
    <img
      src="/plst-logo.png"
      alt={alt}
      width={size}
      height={size}
      className={className}
      style={{ display: "block", height: size, width: size, objectFit: "contain" }}
      draggable={false}
    />
  );
}
